export enum CustomDataProviderType {
    SEISMIC_SLICES = "SEISMIC_SLICES",
    REALIZATION_GRID_3D = "REALIZATION_GRID_3D",
    POLYLINES = "POLYLINES",
}
